import { Button, Modal, Radio } from "antd";
import { BsCaretRightFill } from "react-icons/bs";
import React, { useState } from "react";
import styles from "../../../styles/shared/service-activation/ServiceActivationPaymentMethods.module.css";
import { SiBitcoinsv } from "react-icons/si";
import { FaRegCreditCard } from "react-icons/fa";
import {
  activateServiceWithCard,
  activateServiceWithCrypto,
} from "../../../redux/pricing-plan/action";
import { useDispatch, useSelector } from "react-redux";
import { RiAlertFill } from "react-icons/ri";

function PaymentOptionsModal({ show, setShow, activationMode, amount }) {
  const {
    main: { userData },

    pricingPlan: {
      activateServiceWithCryptoResponse,
      activateServiceWithCryptoStatus: cryptoCheckoutStatus,
      activateServiceWithCardStatus: cardCheckoutStatus,
      activateServiceWithCardResponse,
    },
  } = useSelector((state) => state);

  const [paymentMethod, setPaymentMethod] = useState("crypto");
  const [content, setContent] = useState("methods");

  const dispatch = useDispatch();

  const closeModal = () => {
    setShow(false);
  };

  const selectPaymentMethod = (e) => {
    setPaymentMethod(e.target.value);
    setContent("methods");
  };

  const handlePayment = () => {
    const redirectUrl = window.location.href;
    setContent("result");

    if (paymentMethod === "crypto") {
      dispatch(
        activateServiceWithCrypto(
          userData?.["custom:custom_username"],
          userData?.email,
          activationMode,
          `${amount}`,
          redirectUrl,
          redirectUrl,
        ),
      );
    }

    if (paymentMethod === "card") {
      dispatch(
        activateServiceWithCard(
          userData?.["custom:custom_username"],
          userData?.email,
          activationMode,
          `${amount}`,
          redirectUrl,
          redirectUrl,
        ),
      );
    }
  };

  const handlePayWithCard = () => {
    window.open(
      `${activateServiceWithCardResponse?.checkout_session_url}`,
      "_blank",
    );
  };

  const handlePayWithCrypto = () => {
    window.open(
      `${activateServiceWithCryptoResponse?.checkout_session_url?.data?.invoice_url}`,
      "_blank",
    );
  };

  return (
    <Modal open={show} onCancel={closeModal} centered footer={null}>
      {/*{content === "methods" && (*/}
      {/*  <>*/}
      {/*    <h4>*/}
      {/*      <BsCaretRightFill />*/}
      {/*      Just choose how you'd like to pay:*/}
      {/*    </h4>*/}

      {/*    <Radio.Group*/}
      {/*      className={styles.methods}*/}
      {/*      value={paymentMethod}*/}
      {/*      onChange={selectPaymentMethod}*/}
      {/*    >*/}
      {/*      <Radio value={"crypto"} className={styles.method}>*/}
      {/*        <SiBitcoinsv />*/}
      {/*        Crypto*/}
      {/*      </Radio>*/}
      {/*      <Radio value={"card"} className={styles.method}>*/}
      {/*        <FaRegCreditCard /> Credit Card*/}
      {/*      </Radio>*/}
      {/*    </Radio.Group>*/}

      {/*    <div className={styles.submitBtn}>*/}
      {/*      <Button onClick={handlePayment}>Submit</Button>*/}
      {/*    </div>*/}
      {/*  </>*/}
      {/*)}*/}

      <>
        <h4>
          <BsCaretRightFill />
          Just choose how you'd like to pay:
        </h4>

        <Radio.Group
          className={styles.methods}
          value={paymentMethod}
          onChange={selectPaymentMethod}
        >
          <Radio value={"crypto"} className={styles.method}>
            <SiBitcoinsv />
            Crypto
          </Radio>
          <Radio value={"card"} className={styles.method}>
            <FaRegCreditCard /> Credit Card
          </Radio>
        </Radio.Group>

        {content === "methods" && (
          <div className={styles.submitBtn}>
            <Button onClick={handlePayment}>Submit</Button>
          </div>
        )}
      </>

      {content === "result" && paymentMethod === "card" && (
        <div className={styles.submitBtn}>
          <Button
            className={`${styles.checkoutBtn}`}
            loading={cardCheckoutStatus === "loading"}
            onClick={handlePayWithCard}
            disabled={activateServiceWithCardResponse?.can_proceed !== "True"}
          >
            {cardCheckoutStatus === "loading"
              ? "Preparing your checkout..."
              : "Continue"}
          </Button>
        </div>
      )}

      {content === "result" &&
        paymentMethod === "card" &&
        cardCheckoutStatus === "error" && (
          <>
            <RiAlertFill size={30} color={"#e84118"} />
            <h3>Something went wrong. Please try again later.</h3>
          </>
        )}

      {content === "result" && paymentMethod === "crypto" && (
        <div className={styles.submitBtn}>
          <Button
            className={`${styles.checkoutBtn}`}
            loading={cryptoCheckoutStatus === "loading"}
            onClick={handlePayWithCrypto}
            disabled={
              activateServiceWithCryptoResponse?.can_proceed === "False" ||
              cryptoCheckoutStatus === "error" ||
              activateServiceWithCryptoResponse?.checkout_session_url
                ?.status === "error"
            }
          >
            {cryptoCheckoutStatus === "loading"
              ? "Preparing your checkout..."
              : "Continue"}
          </Button>
        </div>
      )}

      {content === "result" &&
        paymentMethod === "crypto" &&
        (cryptoCheckoutStatus === "error" ||
          activateServiceWithCryptoResponse?.checkout_session_url?.status ===
            "error") && (
          <>
            <RiAlertFill size={30} color={"#e84118"} />
            <h3>Something went wrong. Please try again later.</h3>
          </>
        )}

      {/*{content === "result" && (*/}
      {/*  <DisplayActivationWithPaymentMethodsResponse*/}
      {/*    method={paymentMethod}*/}
      {/*    changeContent={setContent}*/}
      {/*  />*/}
      {/*)}*/}
    </Modal>
  );
}

export default PaymentOptionsModal;
